// extracted by mini-css-extract-plugin
export var statItem = "_l7-1";
export var statsRow = "_l7-0";